//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiChevronRight, mdiChevronLeft } from '@mdi/js'
export default {
  name: 'MobilePager',
  props: {
    page: {
      type: Number,
      default: 0,
    },
    pagesTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      icons: {
        mdiChevronRight,
        mdiChevronLeft,
      },
      valueInput: this.page,
      color: 'inherit',
      idTimeOut: null,
    }
  },
  computed: {
    widthInput() {
      return String(this.valueInput).length * 12
    },
    isDisabled() {
      return this.pagesTotal < 2
    },
  },
  watch: {
    page() {
      this.valueInput = this.page
    },
  },
  methods: {
    onInput(value) {
      clearTimeout(this.idTimeOut)
      this.color = 'inherit'
      if (value === '') {
        return
      }
      const parsed = Number.parseInt(value)
      if (
        value.match('^[0-9]+$') === null ||
        Number.isNaN(parsed) ||
        parsed < 1 ||
        parsed > this.pagesTotal
      ) {
        this.color = 'var(--v-error-base)'
        return
      }
      if (this.valueInput !== this.page) {
        const pager = this
        this.idTimeOut = setTimeout(
          () => pager.$emit('update:page', parsed),
          500
        )
      }
    },
  },
}
